import { ReactElement, useEffect, useState } from "react";
import { Modal, Box, Typography, TextField, Button, Grid2 as Grid } from "@mui/material";
import { updateUser } from "services/UserService";

interface User {
  id: number;
  username: string;
  name: string;
  activo: number;
}

interface Props {
  open: boolean;
  onClose: () => void;
  user: User;
  reload: () => void;
}

const EditUserModal = ({
  open,
  onClose,
  user,
  reload,
}: Props): ReactElement => {
  const [form, setForm] = useState({
    ...user,
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");

  useEffect(() => {
    setForm({ ...user, password: "", confirmPassword: "" });
    setError("");
  }, [user]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    setError("");
    const payload: any = {
      id: form.id,
      username: form.username,
      nombre: form.name,
      activo: form.activo,
    };

    if (form.password.trim() || form.confirmPassword.trim()) {
      if (form.password !== form.confirmPassword) {
        setError("Las contraseñas no coinciden.");
        return;
      }
      payload.key = btoa(form.password); // 🔐 Encriptar en base64 para envío seguro
    }

    await updateUser(payload);
    reload();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          p: 4,
          background: "#fff",
          margin: "10% auto",
          width: 400,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Editar Usuario
        </Typography>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              fullWidth
              name="username"
              label="Username"
              variant="standard"
              value={form.username}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              name="nombre"
              label="Nombre completo"
              variant="standard"
              value={form.name}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              name="password"
              label="Nueva contraseña"
              type="password"
              variant="standard"
              value={form.password}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              fullWidth
              name="confirmPassword"
              label="Confirmar contraseña"
              type="password"
              variant="standard"
              value={form.confirmPassword}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
        {error && (
          <Typography color="error" mt={2}>
            {error}
          </Typography>
        )}
        <Box textAlign="right" mt={3}>
          <Button variant="outlined" onClick={onClose} sx={{ mr: 1 }}>
            Cancelar
          </Button>
          <Button variant="contained" onClick={handleSave}>
            Guardar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditUserModal;
